import makeStyles from '@mui/styles/makeStyles';
import bg from "../../../assets/categories/disegno.svg";
import landingBackground from "../../../assets/newbg.jpg";

export const ContattaciStyle = makeStyles(theme => ({
	main: {
		minHeight: "100vh",
		width: "100%",
		display: "flex",
		alignItems: "center",
		flexDirection: "column",
		backgroundImage: `url(${bg})`,
		backgroundSize: "cover",
		backgroundAttachment: "fixed",
		backgroundRepeat: "no-repeat",
		backgroundPosition: "center 110%",
	},
	header: {
		position: "relative",
		width: "100%",
		paddingTop: 40,
		paddingBottom: 30,
		textAlign: "center",
		[theme.breakpoints.down('md')]: {
			paddingTop: 10,
			paddingBottom: 10,
			paddingLeft: 0,
			paddingRight: 0
		},
	},
	icon: {
		position: "fixed",
		top: 8,
		right: 8
	},
	translateButton: {
		position: "fixed",
		bottom: 8,
		right: 8,
		[theme.breakpoints.down('lg')]: {
			display: "none",
		},
	},
	article: {
		width: "100%",
		display: "flex",
		alignItems: "center",
		flexDirection: "column",
	},
	title: {
		marginTop: theme.spacing(4),
		marginBottom: theme.spacing(2),
		/*marginTop: theme.spacing(10),*/
		color: theme.palette.mode === "light" ? "#FFF" : "#00063d",
		textShadow: theme.palette.mode === "light" ?
			"1px 1px 2px #000" : "1px 1px 2px rgba(255, 255, 255, 0.1)",
		[theme.breakpoints.down('md')]: {
			fontSize: 40
		},
	},
	subTitle: {
		marginLeft: theme.spacing(2),
		color: theme.palette.mode === "light" ? "#FFF" : "#00063d",
		[theme.breakpoints.down('md')]: {
			marginTop: theme.spacing(4),
			fontSize: 20
		},
	},
	noBorder: {
		border: "none",
	},
	searchBar: {
		borderRadius: 24,
		width: 600,
		[theme.breakpoints.down('md')]: {
			width: "98%",
			margin: "auto"
		},
	},
	searchBarFullWidth: {
		borderRadius: 24,
		width: "100%",
		[theme.breakpoints.down('md')]: {
			width: "88%",
			margin: "auto"
		},
	},
	cardContainer: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "center",
		flexWrap: "wrap",
		width: "80%",
		marginTop: theme.spacing(4),
		[theme.breakpoints.down('md')]: {
			marginTop: theme.spacing(4),
			width: "88%",
			marginRight: "auto",
			marginLeft: "auto",
			marginBottom: theme.spacing(4),
		},
	},
	stepperRoot: {
		width: '100%',
		borderRadius: 24
	},
	mdWidth: {
		padding: theme.spacing(3),
		marginTop: theme.spacing(2),
		width: "60%",
		marginRight: "auto",
		marginLeft: "auto",
		marginBottom: theme.spacing(4),
		[theme.breakpoints.down('md')]: {
			marginTop: theme.spacing(1),
			width: "88%",
			marginRight: "auto",
			marginLeft: "auto",
			marginBottom: theme.spacing(4),
		},
	},
	cardMedia: {
		width: 80,
		height: 80,
		margin: "auto",
		marginTop: theme.spacing(2),
		marginBottom: 10
	},
	fullHeight: {
		height: "100%"
	},
	padding1: {
		padding: theme.spacing(1),
	},
	paperTicketCall: {
		width: "100%",
		marginTop: theme.spacing(4),
	},
	paperHeader: {
		padding: theme.spacing(2),
	},
	gridCard: {
		display: "grid",
		gridTemplateRows: "60px 1fr",
		width: "100%"
	},
	"@keyframes landingFloat": {
		"0%, 100%": {
			transform: "translate3d(0, 0, 0) rotate(var(--visual-rotate, 0deg))",
		},
		"50%": {
			transform: "translate3d(0, -12px, 0) rotate(calc(var(--visual-rotate, 0deg) + 1.5deg))",
		},
	},
	"@keyframes landingPulse": {
		"0%, 100%": {
			opacity: 0.72,
			transform: "scale(1)",
		},
		"50%": {
			opacity: 0.95,
			transform: "scale(1.035)",
		},
	},
	"@keyframes landingBrandFloat": {
		"0%, 100%": {
			transform: "translate3d(0, 0, 0) rotate(-0.8deg)",
		},
		"50%": {
			transform: "translate3d(0, -10px, 0) rotate(0.7deg)",
		},
	},
	landingPage: {
		minHeight: "100vh",
		width: "100%",
		position: "relative",
		color: "var(--atl-text)",
		backgroundColor: theme.palette.mode === "light" ? "#d8efff" : "#061321",
		backgroundImage: theme.palette.mode === "light"
			? `linear-gradient(180deg, rgba(244, 250, 255, 0.16) 0%, rgba(236, 247, 255, 0.34) 45%, rgba(221, 241, 252, 0.55) 100%), linear-gradient(135deg, rgba(0, 177, 159, 0.58) 0%, rgba(0, 177, 159, 0) 38%), linear-gradient(235deg, rgba(48, 79, 254, 0.54) 0%, rgba(48, 79, 254, 0) 44%), linear-gradient(35deg, rgba(255, 184, 77, 0.38) 0%, rgba(255, 184, 77, 0) 34%), url(${landingBackground})`
			: `linear-gradient(180deg, rgba(5, 12, 22, 0.12) 0%, rgba(8, 17, 30, 0.46) 48%, rgba(6, 13, 23, 0.82) 100%), linear-gradient(135deg, rgba(0, 177, 159, 0.34) 0%, rgba(0, 177, 159, 0) 40%), linear-gradient(235deg, rgba(74, 132, 255, 0.34) 0%, rgba(74, 132, 255, 0) 46%), linear-gradient(35deg, rgba(56, 189, 248, 0.18) 0%, rgba(56, 189, 248, 0) 34%), url(${landingBackground})`,
		backgroundSize: "cover, cover, cover, cover, cover",
		backgroundPosition: "center, center, center, center, center",
		backgroundAttachment: "fixed",
		overflowX: "hidden",
	},
	landingShell: {
		width: "100%",
		maxWidth: "1795px !important",
		padding: `${theme.spacing(2.5, 4, 3)} !important`,
		[theme.breakpoints.down("md")]: {
			padding: `${theme.spacing(1.5, 2, 2.5)} !important`,
		},
	},
	landingNavShell: {
		position: "fixed",
		top: 0,
		left: "50%",
		zIndex: 30,
		height: "var(--landing-nav-height)",
		transform: "translateX(-50%)",
		pointerEvents: "none",
		isolation: "isolate",
		"&:before": {
			content: '""',
			position: "absolute",
			inset: "0 0 -14px",
			zIndex: -1,
			background: theme.palette.mode === "light"
				? "linear-gradient(180deg, rgba(227,246,255,0.86) 0%, rgba(227,246,255,0.58) 68%, rgba(227,246,255,0) 100%)"
				: "linear-gradient(180deg, rgba(7,16,28,0.88) 0%, rgba(7,16,28,0.64) 68%, rgba(7,16,28,0) 100%)",
			backdropFilter: "blur(14px) saturate(150%)",
			WebkitBackdropFilter: "blur(14px) saturate(150%)",
		},
		"& > *": {
			pointerEvents: "auto",
		},
	},
	landingHeroShell: {
		position: "relative",
		zIndex: 2,
		paddingTop: `${theme.spacing(2.5)} !important`,
		paddingBottom: `${theme.spacing(1)} !important`,
		[theme.breakpoints.down("md")]: {
			paddingTop: `${theme.spacing(1.5)} !important`,
			paddingBottom: `${theme.spacing(0.5)} !important`,
		},
	},
	landingContentShell: {
		position: "relative",
		zIndex: 3,
		paddingTop: `${theme.spacing(1.35)} !important`,
		paddingBottom: `${theme.spacing(12)} !important`,
		[theme.breakpoints.down("md")]: {
			paddingTop: `${theme.spacing(1)} !important`,
			paddingBottom: `${theme.spacing(10)} !important`,
		},
		[theme.breakpoints.down("sm")]: {
			paddingTop: `${theme.spacing(0.8)} !important`,
			paddingBottom: `${theme.spacing(8)} !important`,
		},
	},
	topFloatingActions: {
		position: "fixed",
		top: theme.spacing(2.2),
		right: theme.spacing(4),
		zIndex: 40,
		display: "flex",
		alignItems: "center",
		pointerEvents: "auto",
		[theme.breakpoints.down("md")]: {
			top: theme.spacing(1.5),
			right: theme.spacing(2),
		},
		[theme.breakpoints.down("sm")]: {
			top: theme.spacing(1.15),
			right: theme.spacing(1.15),
		},
	},
	utilityDock: {
		position: "fixed",
		right: theme.spacing(3),
		bottom: theme.spacing(3),
		zIndex: 42,
		display: "grid",
		gap: theme.spacing(0.85),
		padding: 0,
		border: 0,
		background: "transparent",
		boxShadow: "none",
		[theme.breakpoints.down("sm")]: {
			right: theme.spacing(1.2),
			bottom: theme.spacing(1.2),
			gap: theme.spacing(0.55),
		},
	},
	utilityButton: {
		width: "50px !important",
		height: "50px !important",
		border: "1px solid color-mix(in srgb, var(--atl-blue) 42%, var(--atl-border)) !important",
		borderRadius: "999px !important",
		background: theme.palette.mode === "light"
			? "linear-gradient(145deg, rgba(255,255,255,0.66), rgba(255,255,255,0.28)), radial-gradient(circle at 18% 12%, rgba(48,79,254,0.18), transparent 48%) !important"
			: "linear-gradient(145deg, rgba(31,40,54,0.66), rgba(13,22,34,0.36)), radial-gradient(circle at 18% 12%, rgba(79,255,233,0.16), transparent 48%) !important",
		color: "var(--atl-text) !important",
		boxShadow: "0 18px 46px rgba(28, 54, 78, 0.16) !important",
		backdropFilter: "blur(18px) saturate(178%)",
		WebkitBackdropFilter: "blur(18px) saturate(178%)",
		transition: "transform 170ms ease, border-color 170ms ease, box-shadow 170ms ease, background 170ms ease",
		"&:hover": {
			transform: "translateY(-2px)",
			borderColor: "color-mix(in srgb, var(--atl-blue) 68%, var(--atl-border)) !important",
			boxShadow: "0 22px 54px rgba(48, 79, 254, 0.18) !important",
		},
		"& .MuiSvgIcon-root": {
			color: "var(--atl-blue)",
			fontSize: "24px !important",
		},
		[theme.breakpoints.down("sm")]: {
			width: "46px !important",
			height: "46px !important",
		},
	},
	landingTopbar: {
		position: "relative",
		zIndex: 5,
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: theme.spacing(2),
		minHeight: 54,
		marginTop: theme.spacing(0.35),
		padding: theme.spacing(0.55, 0.75, 0.55, 1.05),
		border: "1px solid color-mix(in srgb, var(--atl-border) 76%, transparent)",
		borderRadius: 22,
		background: theme.palette.mode === "light"
			? "linear-gradient(135deg, rgba(255,255,255,0.72), rgba(255,255,255,0.42))"
			: "linear-gradient(135deg, rgba(24,33,47,0.82), rgba(13,22,34,0.58))",
		boxShadow: "0 16px 42px rgba(28, 54, 78, 0.12)",
		backdropFilter: "blur(16px) saturate(155%)",
		WebkitBackdropFilter: "blur(16px) saturate(155%)",
	},
	brandButton: {
		display: "inline-flex",
		alignItems: "center",
		border: 0,
		padding: 0,
		background: "transparent",
		color: "var(--atl-text)",
		cursor: "pointer",
		textAlign: "left",
	},
	brandLogoFrame: {
		display: "block",
		position: "relative",
		width: 152,
		height: 34,
		overflow: "hidden",
	},
	brandLogo: {
		position: "absolute",
		left: -60,
		top: -102,
		display: "block",
		width: 264,
		height: 226,
		filter: theme.palette.mode === "light"
			? "drop-shadow(0 7px 14px rgba(0, 150, 143, 0.12))"
			: "invert(1) drop-shadow(0 10px 22px rgba(0, 255, 244, 0.18))",
	},
	topbarActions: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-end",
		gap: theme.spacing(0.75),
		minWidth: 0,
		flex: "0 1 auto",
		[theme.breakpoints.down("sm")]: {
			gap: theme.spacing(0.7),
		},
	},
	headerButton: {
		minHeight: "38px !important",
		padding: `${theme.spacing(0.7, 1.35)} !important`,
		borderRadius: "999px !important",
		border: "1px solid color-mix(in srgb, var(--atl-border) 86%, transparent) !important",
		background: theme.palette.mode === "light"
			? "linear-gradient(135deg, rgba(255,255,255,0.72), rgba(255,255,255,0.42)) !important"
			: "linear-gradient(135deg, rgba(31,40,54,0.86), rgba(18,27,40,0.58)) !important",
		color: "var(--atl-text) !important",
		backdropFilter: "blur(12px) saturate(155%)",
		WebkitBackdropFilter: "blur(12px) saturate(155%)",
		boxShadow: "0 10px 24px rgba(28, 54, 78, 0.08)",
		textTransform: "none !important",
		fontWeight: "900 !important",
		transition: "transform 170ms ease, border-color 170ms ease, box-shadow 170ms ease, background 170ms ease",
		"&:hover": {
			transform: "translateY(-1px)",
			borderColor: "color-mix(in srgb, var(--atl-cyan) 42%, var(--atl-border)) !important",
			boxShadow: "0 14px 30px rgba(0, 177, 159, 0.13)",
		},
		[theme.breakpoints.down("md")]: {
			minWidth: "38px !important",
			width: "38px !important",
			padding: "0 !important",
			fontSize: "0 !important",
			"& .MuiButton-startIcon": {
				margin: "0 !important",
			},
			"& .MuiSvgIcon-root": {
				fontSize: "22px !important",
			},
		},
	},
	iconButton: {
		width: "38px !important",
		height: "38px !important",
		borderRadius: "999px !important",
		border: "1px solid color-mix(in srgb, var(--atl-border) 86%, transparent) !important",
		background: theme.palette.mode === "light"
			? "linear-gradient(135deg, rgba(255,255,255,0.72), rgba(255,255,255,0.42)) !important"
			: "linear-gradient(135deg, rgba(31,40,54,0.86), rgba(18,27,40,0.58)) !important",
		color: "var(--atl-text) !important",
		backdropFilter: "blur(12px) saturate(155%)",
		WebkitBackdropFilter: "blur(12px) saturate(155%)",
		boxShadow: "0 10px 24px rgba(28, 54, 78, 0.08)",
		transition: "transform 170ms ease, border-color 170ms ease, box-shadow 170ms ease",
		"&:hover": {
			transform: "translateY(-1px)",
			borderColor: "color-mix(in srgb, var(--atl-blue) 42%, var(--atl-border)) !important",
			boxShadow: "0 14px 30px rgba(48, 79, 254, 0.13)",
		},
	},
	loginButton: {
		minHeight: "44px !important",
		maxWidth: "220px",
		padding: `${theme.spacing(0.85, 1.55)} !important`,
		border: "1px solid color-mix(in srgb, var(--atl-blue) 42%, var(--atl-border)) !important",
		borderRadius: "999px !important",
		background: theme.palette.mode === "light"
			? "linear-gradient(145deg, rgba(255,255,255,0.66), rgba(255,255,255,0.28)), radial-gradient(circle at 18% 12%, rgba(48,79,254,0.18), transparent 48%) !important"
			: "linear-gradient(145deg, rgba(31,40,54,0.66), rgba(13,22,34,0.36)), radial-gradient(circle at 18% 12%, rgba(79,255,233,0.16), transparent 48%) !important",
		color: "var(--atl-text) !important",
		boxShadow: "0 18px 46px rgba(28, 54, 78, 0.16) !important",
		backdropFilter: "blur(18px) saturate(178%)",
		WebkitBackdropFilter: "blur(18px) saturate(178%)",
		textTransform: "none !important",
		fontWeight: "900 !important",
		whiteSpace: "normal",
		lineHeight: "1.05 !important",
		transition: "transform 170ms ease, box-shadow 170ms ease, border-color 170ms ease, background 170ms ease",
		"& .MuiSvgIcon-root": {
			color: "var(--atl-blue)",
		},
		"&:hover": {
			transform: "translateY(-2px)",
			borderColor: "color-mix(in srgb, var(--atl-blue) 68%, var(--atl-border)) !important",
			boxShadow: "0 22px 54px rgba(48, 79, 254, 0.18) !important",
		},
		[theme.breakpoints.down("md")]: {
			minWidth: "44px !important",
			width: "44px !important",
			height: "44px !important",
			padding: "0 !important",
			fontSize: "0 !important",
			"& .MuiButton-startIcon": {
				margin: "0 !important",
			},
			"& .MuiSvgIcon-root": {
				fontSize: "22px !important",
			},
		},
	},
	heroSection: {
		position: "relative",
		zIndex: 1,
		display: "grid",
		placeItems: "center",
		minHeight: "min(318px, calc(100vh - 342px))",
		marginTop: theme.spacing(-3),
		padding: theme.spacing(0.25, 0, 0),
		overflow: "visible",
		[theme.breakpoints.down("md")]: {
			minHeight: "auto",
			marginTop: 0,
			padding: theme.spacing(2, 0, 1.5),
		},
	},
	heroContent: {
		position: "relative",
		zIndex: 2,
		display: "grid",
		placeItems: "center",
		width: "min(900px, calc(100% - 72px))",
		margin: "0 auto",
		textAlign: "center",
		pointerEvents: "none",
		transform: "translateY(-8px)",
		[theme.breakpoints.down("md")]: {
			width: "min(720px, calc(100% - 36px))",
			transform: "translateY(-4px)",
		},
	},
	heroTitle: {
		position: "relative",
		isolation: "isolate",
		display: "inline-flex",
		alignItems: "center",
		justifyContent: "center",
		width: "min(720px, 58vw)",
		height: "clamp(148px, 14vw, 188px)",
		padding: 0,
		margin: "0 !important",
		fontSize: "0 !important",
		lineHeight: "1 !important",
		letterSpacing: "0 !important",
		[theme.breakpoints.down("md")]: {
			width: "min(430px, 92vw)",
			height: "clamp(132px, 34vw, 158px)",
			padding: 0,
		},
	},
	heroBrandCard: {
		position: "relative",
		isolation: "isolate",
		display: "grid",
		alignContent: "center",
		justifyItems: "center",
		gap: theme.spacing(1),
		width: "100%",
		height: "100%",
		padding: theme.spacing(2.1, 3.2),
		border: "1px solid color-mix(in srgb, var(--atl-cyan) 34%, var(--atl-border))",
		borderRadius: 30,
		background: theme.palette.mode === "light"
			? "linear-gradient(145deg, rgba(234, 252, 255, 0.7), rgba(182, 222, 238, 0.42)), radial-gradient(circle at 18% 10%, rgba(0, 255, 244, 0.2), transparent 48%)"
			: "linear-gradient(145deg, rgba(31, 40, 54, 0.86), rgba(13, 27, 40, 0.58)), radial-gradient(circle at 18% 10%, rgba(0, 255, 244, 0.16), transparent 48%)",
		color: theme.palette.mode === "light" ? "#009f96" : "var(--atl-cyan)",
		boxShadow: theme.palette.mode === "light"
			? "inset 0 1px 0 rgba(255,255,255,0.62), 0 28px 64px rgba(0, 106, 133, 0.18), 0 12px 32px rgba(0, 255, 244, 0.12)"
			: "inset 0 1px 0 rgba(255,255,255,0.12), 0 30px 72px rgba(0, 0, 0, 0.34), 0 14px 34px rgba(0, 255, 244, 0.13)",
		backdropFilter: "blur(18px) saturate(162%)",
		WebkitBackdropFilter: "blur(18px) saturate(162%)",
		overflow: "hidden",
		fontFamily: '"Montserrat", "Roboto", "Helvetica", "Arial", sans-serif',
		textShadow: theme.palette.mode === "light"
			? "0 8px 22px rgba(0, 106, 133, 0.18), 0 0 18px rgba(0, 255, 244, 0.22)"
			: "0 9px 24px rgba(0, 0, 0, 0.24), 0 0 18px rgba(0, 255, 244, 0.24)",
		animation: "$landingBrandFloat 8.2s ease-in-out infinite",
		"&:before": {
			content: '""',
			position: "absolute",
			inset: 0,
			zIndex: -1,
			background: "linear-gradient(120deg, transparent 0%, rgba(255,255,255,0.24) 34%, transparent 62%)",
			opacity: theme.palette.mode === "light" ? 0.52 : 0.2,
		},
		"&:after": {
			content: '""',
			position: "absolute",
			left: "50%",
			bottom: -42,
			zIndex: -1,
			width: "78%",
			height: 84,
			transform: "translateX(-50%)",
			borderRadius: "50%",
			background: "color-mix(in srgb, var(--atl-cyan) 22%, transparent)",
			filter: "blur(28px)",
			opacity: 0.72,
		},
		[theme.breakpoints.down("md")]: {
			gap: theme.spacing(0.75),
			padding: theme.spacing(1.6, 2),
			borderRadius: 24,
		},
	},
	heroBrandName: {
		display: "block",
		fontSize: "clamp(42px, 5vw, 66px)",
		fontWeight: "850",
		lineHeight: 1,
		letterSpacing: "0 !important",
		textTransform: "uppercase",
	},
	heroBrandSubtitle: {
		display: "block",
		maxWidth: 590,
		color: theme.palette.mode === "light" ? "rgba(24, 57, 74, 0.78)" : "rgba(238,252,255,0.78)",
		fontSize: "clamp(15px, 1.3vw, 18px)",
		fontWeight: "780",
		lineHeight: 1.28,
		textTransform: "none",
		textShadow: "none",
		[theme.breakpoints.down("md")]: {
			maxWidth: 330,
			fontSize: "13px",
			lineHeight: 1.22,
		},
	},
	heroSearch: {
		display: "flex",
		alignItems: "stretch",
		gap: theme.spacing(1),
		width: "min(760px, 100%)",
		marginTop: theme.spacing(3),
		padding: theme.spacing(0.65),
		border: "1px solid var(--atl-border)",
		borderRadius: 18,
		background: "var(--atl-surface)",
		boxShadow: "var(--atl-shadow-strong)",
		backdropFilter: "blur(18px) saturate(150%)",
		WebkitBackdropFilter: "blur(18px) saturate(150%)",
		"& .MuiTextField-root": {
			flex: "1 1 auto",
		},
		"& .MuiOutlinedInput-root": {
			minHeight: 54,
			borderRadius: "14px !important",
			background: theme.palette.mode === "light" ? "rgba(255,255,255,0.72)" : "rgba(24,31,43,0.72)",
			color: "var(--atl-text)",
		},
		"& .MuiOutlinedInput-notchedOutline": {
			border: "0 !important",
		},
		"& .MuiSvgIcon-root": {
			color: "var(--atl-blue)",
		},
		[theme.breakpoints.down("sm")]: {
			flexDirection: "column",
		},
	},
	sectionSearch: {
		flex: "0 1 560px",
		width: "min(560px, 100%)",
		minHeight: 48,
		marginTop: "0 !important",
		padding: `${theme.spacing(0.45)} !important`,
		borderRadius: "16px !important",
		border: theme.palette.mode === "light"
			? "1px solid color-mix(in srgb, var(--atl-border) 72%, transparent)"
			: "1px solid rgba(120, 188, 255, 0.18)",
		background: theme.palette.mode === "light"
			? "linear-gradient(145deg, rgba(226,247,255,0.34), rgba(178,218,235,0.16)), color-mix(in srgb, var(--atl-cyan) 9%, transparent)"
			: "linear-gradient(145deg, rgba(27,47,69,0.74), rgba(12,25,42,0.54)), color-mix(in srgb, var(--atl-cyan) 12%, transparent)",
		boxShadow: theme.palette.mode === "light"
			? "inset 0 1px 0 color-mix(in srgb, #fff 28%, transparent), 0 16px 36px rgba(28, 54, 78, 0.1)"
			: "inset 0 1px 0 rgba(255,255,255,0.12), 0 18px 42px rgba(0, 0, 0, 0.24), 0 0 0 1px rgba(92, 200, 255, 0.04)",
		backdropFilter: "blur(18px) saturate(168%)",
		WebkitBackdropFilter: "blur(18px) saturate(168%)",
		"& .MuiOutlinedInput-root": {
			minHeight: "48px !important",
			borderRadius: "13px !important",
			background: theme.palette.mode === "light"
				? "linear-gradient(145deg, rgba(222,244,252,0.28), rgba(170,211,229,0.14)) !important"
				: "linear-gradient(145deg, rgba(22,43,68,0.88), rgba(13,29,49,0.76)) !important",
			boxShadow: theme.palette.mode === "light"
				? "inset 0 1px 0 color-mix(in srgb, #fff 24%, transparent)"
				: "inset 0 1px 0 rgba(255,255,255,0.1), inset 0 -1px 0 rgba(0,0,0,0.2)",
		},
		"& .MuiInputBase-input": {
			padding: "11px 0 !important",
			fontSize: "15px !important",
			fontWeight: "800 !important",
		},
		"& .MuiInputAdornment-root": {
			marginRight: 4,
		},
		"& $clearButton": {
			minHeight: "44px !important",
			minWidth: "90px !important",
			borderRadius: "13px !important",
			background: theme.palette.mode === "light"
				? "linear-gradient(145deg, rgba(255,255,255,0.52), rgba(255,255,255,0.24)) !important"
				: "linear-gradient(145deg, rgba(31,40,54,0.74), rgba(18,26,38,0.48)) !important",
			backdropFilter: "blur(12px) saturate(150%)",
			WebkitBackdropFilter: "blur(12px) saturate(150%)",
		},
		[theme.breakpoints.down("sm")]: {
			width: "100%",
			flex: "0 1 auto",
		},
	},
	clearButton: {
		minWidth: "96px !important",
		borderRadius: "14px !important",
		background: "var(--atl-surface-solid-strong) !important",
		color: "var(--atl-text) !important",
		border: "1px solid var(--atl-border) !important",
		textTransform: "none !important",
		fontWeight: "850 !important",
		boxShadow: "none !important",
	},
	heroIllustration: {
		position: "absolute",
		zIndex: 0,
		right: "-3%",
		top: "6%",
		width: "min(760px, 50vw)",
		maxHeight: 520,
		opacity: theme.palette.mode === "light" ? 0.86 : 0.62,
		filter: theme.palette.mode === "light"
			? "drop-shadow(0 28px 60px rgba(28, 54, 78, 0.16))"
			: "drop-shadow(0 32px 72px rgba(0, 0, 0, 0.42))",
		pointerEvents: "none",
		[theme.breakpoints.down("md")]: {
			position: "relative",
			right: "auto",
			top: "auto",
			width: "100%",
			maxHeight: 300,
			marginTop: theme.spacing(2),
			order: 2,
		},
		[theme.breakpoints.down("sm")]: {
			maxHeight: 230,
			opacity: theme.palette.mode === "light" ? 0.72 : 0.48,
		},
	},
	visualStage: {
		position: "absolute",
		left: "50%",
		top: "47%",
		transform: "translate(-50%, -50%)",
		width: "min(1360px, 94vw)",
		height: "min(270px, calc(100% - 2px))",
		zIndex: 3,
		pointerEvents: "none",
	},
	visualCard: {
		"--visual-accent": "var(--atl-blue)",
		"--visual-rotate": "0deg",
		position: "absolute",
		zIndex: 2,
		display: "grid",
		placeItems: "center",
		border: "1px solid color-mix(in srgb, var(--visual-accent) 34%, var(--atl-border))",
		borderRadius: 24,
		background: theme.palette.mode === "light"
			? "linear-gradient(145deg, rgba(255,255,255,0.72), rgba(255,255,255,0.42))"
			: "linear-gradient(145deg, rgba(31,40,54,0.84), rgba(20,29,42,0.54))",
		boxShadow: "0 24px 54px color-mix(in srgb, var(--visual-accent) 20%, transparent), var(--atl-shadow)",
		backdropFilter: "blur(16px) saturate(160%)",
		WebkitBackdropFilter: "blur(16px) saturate(160%)",
		animation: "$landingFloat 7.4s ease-in-out infinite",
		overflow: "hidden",
		"&:before": {
			content: '""',
			position: "absolute",
			inset: 0,
			background: "radial-gradient(circle at 18% 12%, color-mix(in srgb, var(--visual-accent) 40%, transparent), transparent 46%)",
			animation: "$landingPulse 5.8s ease-in-out infinite",
		},
		"& svg": {
			position: "relative",
			zIndex: 1,
			width: "76%",
			height: "76%",
		},
	},
	visualCardPerson: {
		"--visual-rotate": "-4deg",
		left: "5%",
		top: "23%",
		width: 172,
		height: 172,
		animationDelay: "-1.4s",
	},
	visualCardDocument: {
		"--visual-rotate": "3deg",
		right: "16%",
		top: "6%",
		width: 226,
		height: 136,
		animationDelay: "-3.2s",
	},
	visualCardCalendar: {
		"--visual-rotate": "-2deg",
		right: "12%",
		bottom: "-5%",
		width: 170,
		height: 134,
		animationDelay: "-2.4s",
	},
	visualCardMessage: {
		"--visual-rotate": "5deg",
		left: "21%",
		top: "8%",
		width: 138,
		height: 98,
		animationDelay: "-4.2s",
	},
	visualCardChart: {
		"--visual-rotate": "2deg",
		left: "22%",
		bottom: "-8%",
		width: 136,
		height: 104,
		animationDelay: "-5.1s",
	},
	visualCardPlus: {
		"--visual-rotate": "-6deg",
		right: "4%",
		top: "31%",
		width: 124,
		height: 124,
		animationDelay: "-0.7s",
	},
	contentSection: {
		position: "relative",
		zIndex: 3,
		marginTop: 0,
		padding: theme.spacing(0, 0, 4),
	},
	landingPathsSection: {
		width: "min(1420px, calc(100% - 72px))",
		margin: "0 auto",
		padding: `${theme.spacing(2.7)} !important`,
		border: theme.palette.mode === "light"
			? "1px solid color-mix(in srgb, var(--atl-border) 78%, rgba(255,255,255,0.48))"
			: "1px solid rgba(130, 194, 255, 0.16)",
		borderRadius: 30,
		background: theme.palette.mode === "light"
			? "linear-gradient(145deg, rgba(255,255,255,0.58) 0%, rgba(238,247,255,0.34) 100%), radial-gradient(circle at 12% 8%, rgba(0,177,159,0.16), transparent 34%), radial-gradient(circle at 88% 14%, rgba(48,79,254,0.18), transparent 36%)"
			: "linear-gradient(145deg, rgba(24,43,62,0.78) 0%, rgba(12,25,42,0.64) 100%), radial-gradient(circle at 12% 8%, rgba(45,212,191,0.2), transparent 36%), radial-gradient(circle at 88% 14%, rgba(96,165,250,0.18), transparent 38%)",
		boxShadow: theme.palette.mode === "light"
			? "0 28px 78px rgba(28, 54, 78, 0.16), var(--atl-shadow)"
			: "0 30px 90px rgba(0, 0, 0, 0.34), inset 0 1px 0 rgba(255,255,255,0.08)",
		backdropFilter: "blur(20px) saturate(172%)",
		WebkitBackdropFilter: "blur(20px) saturate(172%)",
		"& $sectionHeading": {
			alignItems: "center",
			marginBottom: theme.spacing(2),
			paddingBottom: theme.spacing(1.7),
			borderBottom: theme.palette.mode === "light"
				? "1px solid color-mix(in srgb, var(--atl-border) 72%, transparent)"
				: "1px solid rgba(130, 194, 255, 0.14)",
		},
		"& $sectionEyebrow": {
			display: "inline-flex",
			width: "fit-content",
			padding: theme.spacing(0.45, 1),
			border: "1px solid color-mix(in srgb, var(--atl-blue) 28%, var(--atl-border))",
			borderRadius: 999,
			background: "color-mix(in srgb, var(--atl-blue) 10%, transparent)",
		},
		"& $sectionText": {
			padding: theme.spacing(1.15, 1.5),
			border: "1px solid var(--atl-border)",
			borderRadius: 18,
			background: theme.palette.mode === "light"
				? "rgba(255,255,255,0.52)"
				: "rgba(20,29,42,0.52)",
			backdropFilter: "blur(10px) saturate(145%)",
			WebkitBackdropFilter: "blur(10px) saturate(145%)",
		},
		[theme.breakpoints.down("lg")]: {
			width: "min(1180px, calc(100% - 44px))",
			padding: `${theme.spacing(2.4)} !important`,
		},
		[theme.breakpoints.down("sm")]: {
			width: "calc(100% - 16px)",
			padding: `${theme.spacing(1.25)} !important`,
			borderRadius: 24,
			background: theme.palette.mode === "light"
				? "linear-gradient(145deg, rgba(255,255,255,0.46) 0%, rgba(237,248,255,0.28) 100%), radial-gradient(circle at 4% 0%, rgba(0,177,159,0.2), transparent 42%), radial-gradient(circle at 100% 4%, rgba(48,79,254,0.18), transparent 48%)"
				: "linear-gradient(145deg, rgba(28,37,51,0.62) 0%, rgba(14,22,34,0.42) 100%), radial-gradient(circle at 4% 0%, rgba(0,177,159,0.18), transparent 42%), radial-gradient(circle at 100% 4%, rgba(48,79,254,0.16), transparent 48%)",
			boxShadow: "0 20px 48px rgba(28, 54, 78, 0.14)",
			"& $sectionHeading": {
				marginBottom: theme.spacing(1.25),
				paddingBottom: theme.spacing(1.2),
				borderBottom: "1px solid color-mix(in srgb, var(--atl-border) 72%, transparent)",
			},
			"& $sectionEyebrow": {
				marginBottom: theme.spacing(0.55),
			},
		},
	},
	sectionHeading: {
		display: "flex",
		alignItems: "flex-end",
		justifyContent: "space-between",
		gap: theme.spacing(2),
		marginBottom: theme.spacing(2),
		[theme.breakpoints.down("sm")]: {
			alignItems: "stretch",
			flexDirection: "column",
		},
	},
	categoryMainHeading: {
		alignItems: "center !important",
		minHeight: 58,
		"& $sectionTitle": {
			flex: "0 0 auto",
			whiteSpace: "nowrap",
		},
		"& $sectionSearch": {
			flex: "1 1 420px",
			minWidth: 0,
			width: "auto",
		},
		[theme.breakpoints.down("sm")]: {
			display: "flex !important",
			flexDirection: "row !important",
			alignItems: "center !important",
			gap: `${theme.spacing(1)} !important`,
			minHeight: 58,
			"& $sectionTitle": {
				fontSize: "clamp(20px, 4.8vw, 26px) !important",
			},
			"& $sectionSearch": {
				flex: "1 1 auto",
			},
		},
	},
	categoryDrilldownHeading: {
		justifyContent: "flex-start !important",
		alignItems: "center !important",
		gap: `${theme.spacing(1.2)} !important`,
		minHeight: 58,
		[theme.breakpoints.down("sm")]: {
			display: "flex !important",
			flexDirection: "row !important",
			alignItems: "center !important",
			gap: `${theme.spacing(1)} !important`,
			minHeight: 58,
		},
	},
	categoryBackButton: {
		flex: "0 0 auto",
		width: "58px !important",
		height: "58px !important",
		borderRadius: "17px !important",
		border: "1px solid color-mix(in srgb, var(--atl-cyan) 36%, var(--atl-border)) !important",
		background: theme.palette.mode === "light"
			? "linear-gradient(145deg, rgba(255,255,255,0.66), rgba(255,255,255,0.28)) !important"
			: "linear-gradient(145deg, rgba(31,40,54,0.7), rgba(14,22,34,0.42)) !important",
		color: "var(--atl-text) !important",
		boxShadow: "0 12px 28px rgba(28, 54, 78, 0.12) !important",
		backdropFilter: "blur(14px) saturate(165%)",
		WebkitBackdropFilter: "blur(14px) saturate(165%)",
		transition: "transform 170ms ease, border-color 170ms ease, box-shadow 170ms ease",
		"&:hover": {
			transform: "translateX(-2px)",
			borderColor: "color-mix(in srgb, var(--atl-cyan) 64%, var(--atl-border)) !important",
			boxShadow: "0 16px 36px rgba(0, 177, 159, 0.15) !important",
		},
		"& .MuiSvgIcon-root": {
			fontSize: "23px !important",
		},
		[theme.breakpoints.down("sm")]: {
			width: "58px !important",
			height: "58px !important",
			borderRadius: "17px !important",
		},
	},
	sectionEyebrow: {
		margin: "0 0 6px !important",
		color: "var(--atl-blue)",
		fontSize: "12px !important",
		fontWeight: "900 !important",
		textTransform: "uppercase",
	},
	sectionTitle: {
		margin: "0 !important",
		color: "var(--atl-text)",
		fontSize: "clamp(24px, 3vw, 38px) !important",
		fontWeight: "900 !important",
		lineHeight: "1.05 !important",
	},
	sectionText: {
		maxWidth: 430,
		margin: "0 !important",
		color: "var(--atl-text-soft)",
		fontSize: "15px !important",
		fontWeight: "750 !important",
		lineHeight: "1.35 !important",
	},
	categoryGrid: {
		display: "grid",
		gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
		gap: theme.spacing(1.45),
	},
	categoryCard: {
		"--landing-card-color": "var(--atl-blue)",
		"--landing-icon-accent": "var(--landing-card-color)",
		position: "relative",
		isolation: "isolate",
		display: "grid",
		gridTemplateColumns: "56px minmax(0, 1fr) 34px",
		alignItems: "center",
		gap: theme.spacing(1.2),
		minHeight: 108,
		width: "100%",
		padding: theme.spacing(1.35),
		border: theme.palette.mode === "light"
			? "1px solid color-mix(in srgb, var(--landing-card-color) 22%, var(--atl-border))"
			: "1px solid color-mix(in srgb, var(--landing-card-color) 30%, rgba(145, 205, 255, 0.18))",
		borderRadius: 22,
		background: theme.palette.mode === "light"
			? "linear-gradient(145deg, rgba(255,255,255,0.64), rgba(239,249,255,0.34)), radial-gradient(circle at 12% 12%, color-mix(in srgb, var(--landing-card-color) 13%, transparent), transparent 46%)"
			: "linear-gradient(145deg, rgba(27,47,69,0.82), rgba(12,25,43,0.68)), radial-gradient(circle at 12% 12%, color-mix(in srgb, var(--landing-card-color) 24%, transparent), transparent 50%), radial-gradient(circle at 92% 0%, rgba(120,170,255,0.08), transparent 42%)",
		color: "var(--atl-text)",
		boxShadow: theme.palette.mode === "light"
			? "inset 0 1px 0 color-mix(in srgb, #fff 34%, transparent), 0 20px 46px rgba(28, 54, 78, 0.12), 0 18px 38px color-mix(in srgb, var(--landing-card-color) 8%, transparent)"
			: "inset 0 1px 0 rgba(255,255,255,0.1), 0 22px 52px rgba(0, 0, 0, 0.26), 0 18px 42px color-mix(in srgb, var(--landing-card-color) 13%, transparent)",
		backdropFilter: "blur(16px) saturate(160%)",
		WebkitBackdropFilter: "blur(16px) saturate(160%)",
		cursor: "pointer",
		overflow: "hidden",
		textAlign: "left",
		transition: "transform 180ms ease, border-color 180ms ease, box-shadow 180ms ease, background 180ms ease",
		"&:before": {
			content: '""',
			position: "absolute",
			inset: 0,
			zIndex: 0,
			background: "linear-gradient(120deg, transparent 0%, rgba(255,255,255,0.22) 36%, transparent 64%), linear-gradient(135deg, color-mix(in srgb, var(--landing-card-color) 10%, transparent), transparent 66%)",
			opacity: theme.palette.mode === "light" ? 0.48 : 0.16,
			transition: "opacity 180ms ease",
			pointerEvents: "none",
		},
		"&:after": {
			content: '""',
			position: "absolute",
			left: 18,
			right: 18,
			bottom: -34,
			height: 68,
			borderRadius: "50%",
			background: "color-mix(in srgb, var(--landing-card-color) 12%, transparent)",
			filter: "blur(24px)",
			opacity: 0.7,
			pointerEvents: "none",
		},
		"& > *": {
			position: "relative",
			zIndex: 1,
		},
		"&:hover": {
			transform: "translateY(-3px)",
			borderColor: "color-mix(in srgb, var(--landing-card-color) 46%, var(--atl-border))",
			background: theme.palette.mode === "light"
				? "linear-gradient(145deg, color-mix(in srgb, var(--landing-card-color) 24%, rgba(255,255,255,0.72)), color-mix(in srgb, var(--landing-card-color) 14%, rgba(239,249,255,0.42))), radial-gradient(circle at 12% 12%, color-mix(in srgb, var(--landing-card-color) 28%, transparent), transparent 48%), radial-gradient(circle at 92% 46%, color-mix(in srgb, var(--landing-card-color) 16%, transparent), transparent 42%)"
				: "linear-gradient(145deg, color-mix(in srgb, var(--landing-card-color) 30%, rgba(31,52,76,0.84)), color-mix(in srgb, var(--landing-card-color) 18%, rgba(11,24,42,0.72))), radial-gradient(circle at 12% 12%, color-mix(in srgb, var(--landing-card-color) 36%, transparent), transparent 52%), radial-gradient(circle at 92% 46%, color-mix(in srgb, var(--landing-card-color) 22%, transparent), transparent 44%)",
			boxShadow: theme.palette.mode === "light"
				? "inset 0 1px 0 color-mix(in srgb, #fff 38%, transparent), 0 24px 54px rgba(28, 54, 78, 0.14), 0 20px 44px color-mix(in srgb, var(--landing-card-color) 18%, transparent)"
				: "inset 0 1px 0 rgba(255,255,255,0.14), 0 26px 62px rgba(0, 0, 0, 0.3), 0 22px 50px color-mix(in srgb, var(--landing-card-color) 24%, transparent)",
			"&:before": {
				opacity: 1,
			},
			"& $categoryArrow": {
				transform: "translateX(4px)",
				opacity: 1,
			},
			"& $categoryIcon": {
				transform: "scale(1.04)",
				borderColor: theme.palette.mode === "light"
					? "color-mix(in srgb, var(--landing-icon-accent) 52%, rgba(255,255,255,0.64))"
					: "color-mix(in srgb, var(--landing-icon-accent) 44%, rgba(255,255,255,0.7))",
				background: theme.palette.mode === "light"
					? "linear-gradient(145deg, color-mix(in srgb, var(--landing-card-color) 30%, rgba(255,255,255,0.74)), color-mix(in srgb, var(--landing-card-color) 54%, rgba(255,255,255,0.22)))"
					: "linear-gradient(145deg, color-mix(in srgb, var(--landing-card-color) 42%, rgba(44,63,86,0.82)), color-mix(in srgb, var(--landing-card-color) 68%, rgba(16,30,48,0.46)))",
			},
		},
		"&:focus-visible": {
			outline: "3px solid color-mix(in srgb, var(--landing-icon-accent) 36%, transparent)",
			outlineOffset: 3,
		},
	},
	categoryIcon: {
		display: "grid",
		placeItems: "center",
		width: 56,
		height: 56,
		border: theme.palette.mode === "light"
			? "1px solid color-mix(in srgb, var(--landing-icon-accent) 34%, rgba(255,255,255,0.58))"
			: "1px solid color-mix(in srgb, var(--landing-icon-accent) 34%, rgba(255,255,255,0.5))",
		borderRadius: 17,
		background: theme.palette.mode === "light"
			? "linear-gradient(145deg, color-mix(in srgb, var(--landing-card-color) 26%, rgba(255,255,255,0.76)), color-mix(in srgb, var(--landing-card-color) 46%, rgba(255,255,255,0.24)))"
			: "linear-gradient(145deg, color-mix(in srgb, var(--landing-card-color) 36%, rgba(44,63,86,0.82)), color-mix(in srgb, var(--landing-card-color) 60%, rgba(16,30,48,0.5)))",
		boxShadow: theme.palette.mode === "light"
			? "0 16px 30px color-mix(in srgb, var(--landing-card-color) 22%, transparent), inset 0 1px 0 color-mix(in srgb, #fff 42%, transparent)"
			: "0 16px 34px color-mix(in srgb, var(--landing-card-color) 24%, transparent), inset 0 1px 0 rgba(255,255,255,0.18)",
		backdropFilter: "blur(12px) saturate(150%)",
		WebkitBackdropFilter: "blur(12px) saturate(150%)",
		transition: "transform 180ms ease, border-color 180ms ease",
		"& .MuiSvgIcon-root": {
			margin: "0 !important",
			color: theme.palette.mode === "light"
				? "var(--landing-icon-color, var(--landing-card-color)) !important"
				: "color-mix(in srgb, var(--landing-icon-color, var(--landing-card-color)) 58%, white) !important",
			fontSize: "29px !important",
		},
	},
	categoryBody: {
		display: "grid",
		gap: 0,
		minWidth: 0,
		"& strong": {
			color: "var(--atl-text)",
			fontSize: 16.5,
			fontWeight: 900,
			lineHeight: 1.14,
			overflowWrap: "anywhere",
			textShadow: theme.palette.mode === "light" ? "none" : "0 1px 14px rgba(0,0,0,0.28)",
		},
		"& small": {
			color: "var(--atl-text-soft)",
			fontSize: 12,
			fontWeight: 850,
			lineHeight: 1.1,
		},
	},
	categoryArrow: {
		color: theme.palette.mode === "light"
			? "var(--landing-icon-accent)"
			: "color-mix(in srgb, var(--landing-icon-accent) 58%, white)",
		justifySelf: "end",
		opacity: theme.palette.mode === "light" ? 0.72 : 0.86,
		transition: "opacity 180ms ease, transform 180ms ease",
	},
	faqPanel: {
		display: "grid",
		gap: theme.spacing(1),
		padding: theme.spacing(1),
		border: "1px solid var(--atl-border)",
		borderRadius: 20,
		background: theme.palette.mode === "light"
			? "linear-gradient(180deg, rgba(255,255,255,0.82) 0%, rgba(255,255,255,0.66) 100%)"
			: "linear-gradient(180deg, rgba(31,40,54,0.9) 0%, rgba(24,31,43,0.76) 100%)",
		boxShadow: "var(--atl-shadow)",
		backdropFilter: "blur(14px) saturate(148%)",
		WebkitBackdropFilter: "blur(14px) saturate(148%)",
	},
	faqHelperText: {
		margin: "0 !important",
		padding: theme.spacing(0.8, 1.25, 0.2),
		color: "var(--atl-text-soft)",
		fontSize: "13px !important",
		fontWeight: "800 !important",
		lineHeight: "1.25 !important",
	},
	emptyState: {
		margin: "0 !important",
		padding: theme.spacing(2),
		color: "var(--atl-text-soft)",
		fontSize: "15px !important",
		fontWeight: "800 !important",
	},
	secondaryButton: {
		borderRadius: "14px !important",
		border: "1px solid var(--atl-border) !important",
		background: "var(--atl-surface) !important",
		color: "var(--atl-text) !important",
		textTransform: "none !important",
		fontWeight: "850 !important",
		backdropFilter: "blur(12px) saturate(145%)",
		WebkitBackdropFilter: "blur(12px) saturate(145%)",
	},
	landingFooter: {
		display: "flex",
		justifyContent: "center",
		padding: theme.spacing(3, 0, 5),
		color: "var(--atl-text-soft)",
	},
	mobileTopbar: {
		minHeight: 46,
		marginTop: 0,
		padding: theme.spacing(0.45, 0.55, 0.45, 0.75),
		borderRadius: 18,
		"& $brandLogo": {
			width: 136,
			height: 38,
		},
		"& $brandButton": {
			gap: theme.spacing(0.25),
		},
		"& $brandButton small": {
			display: "none",
		},
		"& $topbarActions": {
			gap: theme.spacing(0.45),
		},
		"& $headerButton, & $iconButton, & $loginButton": {
			width: "36px !important",
			height: "36px !important",
			minHeight: "36px !important",
			borderRadius: "999px !important",
		},
	},
	mobileHeroSection: {
		position: "relative",
		zIndex: 1,
		isolation: "isolate",
		display: "grid",
		gridTemplateColumns: "1fr",
		alignContent: "start",
		gap: theme.spacing(0.9),
		minHeight: 252,
		padding: theme.spacing(1, 0, 0),
		overflow: "visible",
		"&:before": {
			content: '""',
			position: "absolute",
			inset: theme.spacing(5.6, -2, 3.5),
			zIndex: -1,
			borderRadius: 32,
			background: theme.palette.mode === "light"
				? "radial-gradient(circle at 8% 28%, rgba(0,177,159,0.32), transparent 42%), radial-gradient(circle at 92% 22%, rgba(48,79,254,0.34), transparent 46%), radial-gradient(circle at 62% 100%, rgba(255,184,77,0.28), transparent 42%)"
				: "radial-gradient(circle at 8% 28%, rgba(0,177,159,0.24), transparent 42%), radial-gradient(circle at 92% 22%, rgba(48,79,254,0.28), transparent 46%), radial-gradient(circle at 62% 100%, rgba(255,77,109,0.2), transparent 42%)",
			filter: "saturate(1.1)",
		},
	},
	mobileHeroText: {
		position: "relative",
		zIndex: 2,
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		textAlign: "center",
	},
	mobileHeroTitle: {
		position: "relative",
		isolation: "isolate",
		display: "inline-flex",
		alignItems: "center",
		justifyContent: "center",
		width: "min(430px, 92vw)",
		height: "clamp(132px, 34vw, 158px)",
		padding: 0,
		margin: "0 !important",
		color: "transparent",
		fontSize: "0 !important",
		fontWeight: "300 !important",
		lineHeight: "0.94 !important",
		letterSpacing: "0 !important",
		"& $heroBrandName": {
			fontSize: "clamp(31px, 8.2vw, 45px)",
		},
	},
	mobileHeroIllustration: {
		position: "relative",
		zIndex: 1,
		justifySelf: "center",
		width: "min(320px, 84vw)",
		maxHeight: 176,
		margin: theme.spacing(-0.7, 0, -0.6),
		opacity: theme.palette.mode === "light" ? 0.78 : 0.52,
		filter: theme.palette.mode === "light"
			? "drop-shadow(0 18px 38px rgba(28, 54, 78, 0.13))"
			: "drop-shadow(0 22px 48px rgba(0, 0, 0, 0.4))",
		pointerEvents: "none",
	},
	mobileVisualStage: {
		position: "absolute",
		left: "50%",
		top: 62,
		transform: "translateX(-50%)",
		justifySelf: "auto",
		width: "min(460px, 112vw)",
		height: 142,
		margin: 0,
		zIndex: 1,
		"& $visualCard": {
			borderRadius: 18,
			animationDuration: "8.4s",
		},
		"& $visualCardDocument": {
			right: "-2%",
			top: "2%",
			width: 104,
			height: 66,
		},
		"& $visualCardPerson": {
			left: "-2%",
			top: "38%",
			width: 78,
			height: 78,
		},
		"& $visualCardCalendar": {
			right: "11%",
			bottom: "0%",
			width: 72,
			height: 60,
		},
		"& $visualCardMessage": {
			left: "11%",
			top: "0%",
			width: 76,
			height: 58,
		},
		"& $visualCardChart": {
			left: "8%",
			bottom: "0%",
			width: 62,
			height: 54,
		},
		"& $visualCardPlus": {
			right: "2%",
			top: "44%",
			width: 56,
			height: 56,
		},
	},
	mobileSearchDock: {
		position: "relative",
		zIndex: 5,
		marginTop: "0 !important",
		padding: `${theme.spacing(0.5)} !important`,
		borderRadius: "16px !important",
		boxShadow: "0 14px 32px rgba(28, 54, 78, 0.12)",
		"& .MuiOutlinedInput-root": {
			minHeight: "48px !important",
			borderRadius: "13px !important",
		},
		"& .MuiInputBase-input": {
			fontSize: "15px !important",
			fontWeight: "750 !important",
		},
		"& $clearButton": {
			width: "100%",
			minHeight: "42px !important",
		},
	},
	mobileContentSection: {
		marginTop: 0,
		padding: theme.spacing(1.2, 0, 2.2),
	},
	mobileSectionHeading: {
		display: "block",
		marginBottom: theme.spacing(1),
	},
	mobileCategoryList: {
		display: "grid",
		gap: theme.spacing(1.05),
	},
		mobileCategoryCard: {
			gridTemplateColumns: "48px minmax(0, 1fr) 28px",
			minHeight: "84px",
			padding: theme.spacing(1),
			borderColor: "color-mix(in srgb, var(--landing-card-color) 42%, var(--atl-border))",
			borderRadius: "19px !important",
			background: theme.palette.mode === "light"
				? "linear-gradient(145deg, color-mix(in srgb, var(--atl-surface-solid-strong) 72%, rgba(255,255,255,0.58)) 0%, color-mix(in srgb, var(--atl-surface-solid) 78%, rgba(255,255,255,0.28)) 100%)"
				: "linear-gradient(145deg, color-mix(in srgb, var(--atl-surface-solid-strong) 78%, rgba(31,40,54,0.58)) 0%, color-mix(in srgb, var(--atl-surface-solid) 82%, rgba(20,29,42,0.38)) 100%)",
			boxShadow: "inset 5px 0 0 color-mix(in srgb, var(--landing-card-color) 76%, transparent), inset 0 1px 0 color-mix(in srgb, #fff 30%, transparent), 0 16px 34px rgba(28, 54, 78, 0.1)",
			backdropFilter: "blur(15px) saturate(154%)",
			WebkitBackdropFilter: "blur(15px) saturate(154%)",
		"&:active": {
			transform: "scale(0.985)",
		},
		"&:before": {
			width: 6,
		},
		"& $categoryIcon": {
			width: 48,
			height: 48,
			borderRadius: 15,
			"& .MuiSvgIcon-root": {
				fontSize: "26px !important",
			},
		},
		"& $categoryBody": {
			gap: 3,
		},
		"& $categoryBody strong": {
			fontSize: 15.5,
			lineHeight: 1.08,
		},
		"& $categoryBody small": {
			fontSize: 11.5,
		},
		"& $categoryArrow": {
			display: "grid",
			placeItems: "center",
			width: 28,
			height: 28,
			borderRadius: 10,
			background: "color-mix(in srgb, var(--landing-card-color) 13%, transparent)",
			fontSize: 22,
			opacity: 1,
		},
	},
	mobileFaqPanel: {
		padding: theme.spacing(0.65),
		borderRadius: 16,
	},
	languageMenuPaper: {
		minWidth: 260,
		border: "1px solid var(--atl-border) !important",
		borderRadius: "16px !important",
		background: "var(--atl-surface-strong) !important",
		color: "var(--atl-text) !important",
		boxShadow: "var(--atl-shadow-strong) !important",
		backdropFilter: "blur(14px) saturate(148%) !important",
		WebkitBackdropFilter: "blur(14px) saturate(148%) !important",
	},
	languageItem: {
		display: "flex",
		gap: theme.spacing(1),
		minHeight: "42px !important",
		fontWeight: "800 !important",
	},
}))
